<template>
	<modal
		:title="title"
		id="create_addendum"
		cancel-label="Close"
		continue-label="Save changes"
		v-on:closed="cancel"
		v-on:confirm="saveChanges"
    :showModal="showModal"
	>
		<template v-slot:body>
			<div class="form-horizontal">
        <div class="form-group row" v-if="errors.length">
          <div class="alert alert-danger">
              <b>Please correct the following error(s):</b>
              <ul>
                <li v-for="error in errors" :key="error">{{ error }}</li>
              </ul>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-sm-2 col-sm-offset-1">
            <label for="addendum">Version:</label>
          </div>
          <div class="col-sm-7">
            <select class="form-control" v-model="version">
              <option v-for="version in versions" :key="version.id">{{ version }}</option>
            </select>
          </div>
     		</div>
		    <br />
		    <div class="form-group row">
		      <div class="col-sm-2 col-sm-offset-1">
		        <label for="addendum">Name:</label>
		      </div>
          <div class="col-sm-7">
            <input type="text" v-model="name" class="form-control col-sm-7" id="addendum"  v-on:keydown.enter.stop="saveChanges"/>
          </div>
		    </div>
			</div>
		</template>
	</modal>
</template>

<script setup>
	import { ref, computed } from 'vue'
	import Modal from '../../Modal.vue'

	const props = defineProps(['showModal', 'consent', 'versions'])
  const emit = defineEmits(['input', 'closed', 'confirm'])
	const version = ref(null)
	const name = ref(null)
  const errors = ref([])

	function saveChanges() {
    let validated = validateForm()
    if (validated) {
			let data = {}
			data.version = version.value
			data.name = name.value
      data.consent_id = props.consent.id
			emit('confirm', data)
      emit('input', false)
      clearForm()
    }
	}
  
  function cancel() {
		emit('closed')
    emit('input', false)
    clearForm()
	}

  function clearForm() {
    version.value = null
    name.value = null
    errors.value = []
  }
	
	function validateForm() {
    if (version.value && name.value) {
      return true
    }
    if (!version.value) {
      errors.value.push("Version required.")
    }
    if (!name.value) {
      errors.value.push("Name required.")
    }
    if (errors.value.length) {
      return false
    }
	}
		
	const title = computed(() => {
		return "Add Addendum for "+ props.consent.name
	})
</script>